import { RoadmapIcon } from "../../../assets";

function RoadmapElement(props: any) {

  return (
    <>
      <div className="flex justify-center mb-1">
        <img alt="Roadmap Bullet" src={RoadmapIcon} className="w-5 mr-5" />
        <h1 className="text-4xl font-gobold">{props.title}</h1>
      </div>
      <p className="text-xl pl-10 font-light mb-6">{props.text}</p>
    </>
  );
}

export default RoadmapElement;
